import React from "react";

const CurrencyContext = React.createContext();

export const CurrencyContextProvider = CurrencyContext.Provider;
export const CurrencyContextConsumer = CurrencyContext.Consumer;
export default CurrencyContext;
